import store from './../game/store/index.js';
import config from './../config/config.js';
import * as turf from "@turf/turf";


const worker = {
	install(Vue, options) {

		const $auth = Vue.prototype.$auth;
		const $geo = Vue.prototype.$geo;
		const $zone = Vue.prototype.$zone;
		const $asset = Vue.prototype.$asset;
		const $finder = Vue.prototype.$finder;

		Vue.prototype.$worker = {
			getName(worker_id) {
				let worker = store.state.workers[worker_id];
				if (!worker) return null;
				if ($auth.hasAccess('worker.name')) {
					return worker.first_name+' '+worker.last_name;
				}

				return worker.badge_number;
			},
			getIcon(worker) {
				let icon = config.job_types[worker.job].img;
				return require('assets/img/sprites/'+icon);
			},
			getVehicle(worker_id, type) {
				if (!type) type = 'transport';
				let vehicles = $finder.all({type: type}, store.state.vehicles);
				for (let i in vehicles) {
					let vehicle = vehicles[i];
					if (vehicle.workers.includes(worker_id)) return vehicle;
				}
				return null;
			},
			getClosestParking(worker) {
				let drawLayer = store.state.map.drawLayer;
				let vehicle = this.getVehicle(worker.id);

				let vehicle_point = turf.point($geo.toTurf(vehicle.coordinates));

				let feature = drawLayer.getClosestFeatureToCoordinate(worker.coordinates, (feature) => { return feature.type == 'parking' && turf.booleanPointInPolygon(vehicle_point, feature.turf); });

				let current_zone = this.getRealZone(worker);

				if (feature) {
					if (current_zone && !$zone.zonesAreClose(feature.id, current_zone, 350) ) feature = null;
					else if (!$zone.zoneIsClose(feature.id, worker.coordinates, 350)) feature = null
				}


				if (!feature) feature = drawLayer.getClosestFeatureToCoordinate(worker.coordinates, (feature) => { return feature.type == 'parking' });

				return feature;
			},
			getRealZone(worker) {
				let drawLayer = store.state.map.drawLayer;
				let features = drawLayer.getFeaturesAtCoordinate(worker.coordinates);
				let real_zone;
				features.forEach((feature) => {
					let zone = store.state.zones[feature.id];
					if (zone.floor_level == worker.floor_level) real_zone = zone;
				});

				return real_zone;
			},
			getSprite(worker) {
				if (!isNaN(worker)) worker = store.state.workers[worker];
				return store.state.sprites[worker.id];
			},
			getClosestDriver(vehicle) {
				if (!isNaN(vehicle)) vehicle = store.state.vehicles[vehicle];

				let workers = $asset.workersInVehicle(vehicle);
				workers.forEach(worker => {
					if (worker.driver) return worker;
				});
				if (workers.length) return workers[0];

				if (!vehicle.zone) return null;

				let target_zone;
				for (let i in store.state.zones) {
					let zone = store.state.zones[i];
					if (zone.parking_zone_id == vehicle.zone.id) {
						target_zone = zone;
					}
				}

				if (!target_zone) return null;

				for (let i in store.state.workers) {
					let worker = store.state.workers[i];
					if (worker.zone.id == target_zone.id) return worker;
				}

				return null;

			},
			hasRoute(worker) {
				return worker.route && worker.route.length;
			},
			requiresTransportation(worker, route_ref) {

				if (!route_ref) return false;
				let route = [...route_ref];

				// let current_zone = this.getRealZone(worker);
				// if (current_zone) route.unshift({zone_id: current_zone.id});


				for (let i in route) {
					let zone_id = route[i].zone_id;
					let zone = store.state.zones[zone_id];
					if (store.state.location.max_walking_distance) {
						if (!$zone.zoneIsClose(zone.id, worker.coordinates, store.state.location.max_walking_distance)) return true;
					}
					else if (zone.vehicles.includes('transport')) return true;

				};

				return false;

			}
		}
	}
};

export default worker;
